module.exports = __webpack_public_path__ + "static/media/firmness.54dd0b26.svg";